
import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { DataCollectorService } from '../core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from '../core/services/utility_functions/utility_functions.service';


@Directive({
    selector: '[apiLazyLoading]'
})
export class APILazyLoadingDirective implements OnInit {
    @Input() dataURL: any;
    @Input() params: any;
    @Input() totalPages: number;
    @Input() fetchData: boolean = true;
    @Output() isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() emitter: EventEmitter<any> = new EventEmitter<any>();

    scrolledEnd: boolean = false;
    currentHeight: any;

    constructor(
        private utilityService: UtilityService,
        private dataCollectorService: DataCollectorService,
        private elementRef: ElementRef,
    ) { }

    @HostListener('scroll', ['$event'])
    onContainerScroll(event: any): void {
        const hostElement: HTMLElement = this.elementRef.nativeElement;
        if ((hostElement.offsetHeight + hostElement.scrollTop + 2 >= hostElement.scrollHeight) && !this.scrolledEnd && !(this.currentHeight >= hostElement.scrollHeight)) {
            this.scrolledEnd = true;
            this.emitter.emit({
                scrolledToEnd: this.scrolledEnd
            });
            if (this.fetchData && (this.params?.page < this.totalPages)) {
                this.getData();
            }
        } else {
            this.scrolledEnd = false;
            this.currentHeight = hostElement.offsetHeight + hostElement.scrollTop + 2;
        }
    }

    ngOnInit(): void {
    }

    getData(): void {
        let urlParams: any;
        if (this.params) {
            this.params.page++;
            urlParams = this.utilityService.constructParam(this.params);
        }
        this.isLoading.emit(true);
        this.dataCollectorService.getData(this.dataURL, urlParams).subscribe(
            (response: any) => {
                this.isLoading.emit(false);
                this.emitter.emit({ fetchedData: response.data });
            }, (error: any) => {
            });
    }
}
